import Base from './Base'
import gsap from 'gsap'

import { evt, utils, store } from '@/core'

import { lenis } from '../app'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()
		store.Highway.on('NAVIGATE_END', ({ location }) => {
			// Check Anchor
			if (location.anchor) {
			// Get element
			const el = document.querySelector(location.anchor);
			console.log(el)
		
			if (el) {
				// Scroll to element
				lenis.scrollTo(location.anchor)
			}
			}
		});
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}

}